import { Button, Header } from "@/presentation/components";
import { DataTable, DataTableColumn } from "@/presentation/components/common/DataTable";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { BottomAppBar } from "@/presentation/components/layout/BottomAppBar";
import { useAuthContext } from "@/presentation/context";
import { useUbicacion } from "@/presentation/hooks/UseUbicacion";
import { routes } from "@/presentation/router";
import { Categories } from "@/shared";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import './IncidentePage.css';
import { useSimple } from "@/presentation/hooks/useSimple";

import { UbicacionParamsDTO } from "@/application";
import { CreateDialog } from "../action/components/CreateActionDialog";
import { Form } from "@/presentation/components/Forms/Form/Form";

export default function UbicacionesPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const {
    ubicaciones,
    loading,
    error,
    loadAll,
  } = useUbicacion();
  const [openFilters, setOpenFilters] = useState(false)
  const {
    data: grupos,
    reload: loadGrupos,
  } = useSimple('luc_ubicaciones_grupo');
  const grupoOptions = useMemo(
    () =>
      grupos.map((grupo) => ({
        value: grupo.id,
        label: grupo.nombre,
      })),
    [grupos]
  );





  const handleFilterClick = async () => {
    await loadGrupos()
    setOpenFilters(true)
  };
  const [params, setParams] =
    useState<UbicacionParamsDTO>({
      pages: 1
    });

  useEffect(() => {
    loadAll(params);
  }, [params, loadAll]);

  const handleFilter = (
    values: UbicacionParamsDTO
  ) => {
    setParams((current) => ({
      ...current,
      ...values,
      pages: 1,
      nombre: values.nombre?.trim() || undefined,
    }));

    setOpenFilters(false);
  };


  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };

  const columns: DataTableColumn<any>[] = [

    {
      key: 'nombre',
      header: 'Ubicación',
    },
    {
      key: 'grupo',
      header: 'Grupo',
    },

    {
      key: 'cp',
      header: 'Categoría',
      render: (value) =>
        Categories(value.cp),
    },
    {
      key: 'direccion',
      header: 'Direccion',
    },
    {
      key: 'provincia',
      header: 'Provincia',

    },
  ];

  const nuevoUbicacion = () => {
    navigate('/ubicacion/formulario/0', { replace: true });
  };

  const clearFilters = () => {
    setParams(
      {
        pages: 1
      });
  }
  function nuevogrupo(): void {
    navigate('/simples/luc_ubicaciones_grupo', { replace: true });
  }
  const categoriesOptions = [
    {
      value: 1,
      label: 'Stock'
    },
    {
      value: 2,
      label: 'CEL'
    },
    {
      value: 3,
      label: 'Taller'
    },
    {
      value: 4,
      label: 'Prestador'
    },
    {
      value: 5,
      label: 'CEL (Particulares)'
    },
    {
      value: 6,
      label: 'CRI'
    },
    {
      value: 7,
      label: 'CGP'
    },
    {
      value: 8,
      label: 'CEL IDX'
    },
  ]

  return (
    <div>
      <Header
        title="Ubicaciones"
        onMenuClick={handleOpenDrawer}
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />

      <main className="incidentes-page">
        <div className="incidentes-page__toolbar">
          <Button
            onClick={clearFilters}
            disabled={loading}
          >
            Borrar Filtros
          </Button>

          <Button
            onClick={handleFilterClick}
            disabled={loading}
          >
            Filtrar
          </Button>
        </div>

        {loading && (
          <p className="incidentes-page__message">
            Cargando incidentes...
          </p>
        )}

        {error && (
          <p className="incidentes-page__error">
            {error}
          </p>
        )}

        {!loading && !error && (
          <DataTable
            columns={columns}
            data={ubicaciones}
            onRowClick={(ubicacion) =>
              navigate(`/ubicacion/${ubicacion.id}`)
            }
            emptyMessage="No hay Ubicaciones cargados"
            page={params.pages ?? 1}
            hasPrevious={(params.pages ?? 1) > 1}
            hasNext={ubicaciones.length === 25}
            onPrevious={() =>
              setParams((current) => ({
                ...current,
                pages: Math.max(
                  1,
                  (current.pages ?? 1) - 1
                ),
              }))
            }
            onNext={() =>
              setParams((current) => ({
                ...current,
                pages: (current.pages ?? 1) + 1,
              }))
            }
          />
        )}
      </main>
      <BottomAppBar
        items={[
          {
            label: 'Nuevo Ubicacion',
            onClick: nuevoUbicacion,
            icon: undefined,
          },

          {
            label: 'Nuevo Grupo',
            onClick: nuevogrupo,
            icon: undefined,
          },
        ]}
      />
      <CreateDialog
        open={openFilters}
        title="Filtros"
        onClose={() => setOpenFilters(false)}
      >
        <Form
          fields={[
            {
              name: 'grupo',
              label: 'Grupo',
              type: 'select',
              options: grupoOptions,
              optional: true
            },
            {
              name: 'nombre',
              label: 'Ubicación',
              type: 'text',
              optional: true
            },
            {
              name: 'cp',
              label: 'Categoría',
              type: 'select',
              options: categoriesOptions,
              optional: true
            }

          ]}
          submitLabel="Aceptar"
          onSubmit={handleFilter}
        />
      </CreateDialog>
    </div>
  );
}
